import { render, staticRenderFns } from "./OutsourceFormModal.vue?vue&type=template&id=67842c0f"
import script from "./OutsourceFormModal.vue?vue&type=script&lang=js"
export * from "./OutsourceFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports